<template>
  <!-- <div class="ancollextbox andetail box"> -->
  <div class="ancollextbox andetail box">
    <div class="left_content">
      <div class="leftside" v-if="leftsideArr.length>1">
        <p>医案</p>
        <div
          v-for="(item,index) in leftsideArr"
          :key="index"
          @click="goAnchor(item.to)"
        >{{item.name}}</div>
      </div>
    </div>
    <div class="andetail_content">
      <p class="breakhead book_nav" v-if="breakArr.type == 1">
        <router-link to="index" tag="span" class="nav_home">首页</router-link>
        <span class="nav_middle" @click="goindex(2)">医案库</span>
        <span class="nav_middle" @click="goablist(1)">{{breakArr.ksname}}</span>
        <span class="nav_current">{{breakArr.name}}</span>
      </p>
      <p class="breakhead book_nav" v-if="breakArr.type == 2">
        <router-link to="index" tag="span" class="nav_home">首页</router-link>
        <span class="nav_middle" @click="goindex(2)">推荐医家</span>
        <span class="nav_middle" @click="goablist(2)">{{breakArr.name}}</span>
        <span class="nav_current">{{breakArr.ksname}}</span>
      </p>
      <p class="breakhead book_nav" v-if="breakArr.type == 3">
        <router-link to="index" tag="span" class="nav_home">首页</router-link>
        <span class="nav_middle" @click="goindex(2)">医案库</span>
        <span class="nav_middle" @click="goablist(2)">{{breakArr.name}}</span>
        <span class="nav_current">{{breakArr.ksname}}</span>
      </p>
      <p class="breakhead book_nav" v-if="breakArr.type == 4">
        <router-link to="index" tag="span" class="nav_home">首页</router-link>
        <span class="nav_middle" @click="goindex(2)">医案库</span>
        <span class="nav_current">{{breakArr.name}}</span>
      </p>
      <!-- {{detailtArr}} -->
      <h3 class="andetail_title">
        <!-- <span v-if="isfree">限时免费</span> -->
        {{case_name}}
        <!-- <img src="../../assets/index/time_label.png" alt /> -->
      </h3>

      <div class="andetail_div">
        <div id="andetail_one">
          <div class="andetail_first" v-for="(pitem,pindex) in detailtArr_first" :key="pindex">
            <div
              class="andetail_p"
              v-for="(item,index) in pitem"
              :key="index"
              v-if="item.value.length>0"
            >
              <p
                v-if="item.name.length >4"
                class="andetail_p_name"
                :style="'width: '+item.name.length*17.6+'px;'"
              >{{item.name}}</p>
              <p v-else class="andetail_p_name">{{item.name}}</p>
              <!-- <p>{{item.value[0]}}</p> -->
              <!-- :style="'width: calc(100% - '+item.name.length*20+'px);'"> -->
              <p class="andetail_p_content">
                <span v-for="(bitem,bindex) in item.value">{{bitem}}</span>
              </p>
            </div>
          </div>
        </div>
        <div
          class="andetail_follow"
          :id="'andetail_follow_'+ppindex"
          v-for="(ppitem,ppindex) in detailtArr_follow"
          :key="ppindex"
        >
          <div class="andetail_follow_title">
            <p>{{follow_title[ppindex]}}诊</p>
          </div>
          <!-- <a v-if="leftsideArr.length>1" :name="leftsideArr[ppindex+2].to"></a> -->
          <div class="andetail_first" v-for="(pitem,pindex) in ppitem" :key="pindex">
            <div
              class="andetail_p"
              v-for="(item,index) in pitem"
              :key="index"
              v-if="item.value.length>0"
            >
              <p
                v-if="item.name.length >4"
                class="andetail_p_name"
                :style="'width: '+item.name.length*17+'px;'"
              >{{item.name}}</p>
              <p v-else class="andetail_p_name">{{item.name}}</p>
              <!-- <p>{{item.value[0]}}</p> -->
              <p class="andetail_p_content">
                <span v-for="(bitem,bindex) in item.value" :key="bindex">{{bitem}}</span>
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="buy_now" v-if="islogin">
            <div v-if="is_c" @click="alertdialog">查看全文</div>
        </div>
        <div class="buy_now" v-else>
          <p>还有&nbsp;{{percentage}}&nbsp;的精彩内容</p>
          <router-link tag="div" to="login">登录阅读全文</router-link>
        </div> -->
        <!-- <div class="buy_now" v-if="need_buy">
          <p>还有&nbsp;{{percentage}}&nbsp;的精彩内容</p>
          <div v-if="islogin" @click="buy_now">支付&nbsp;￥{{price}}&nbsp;继续阅读</div>
          <router-link v-else tag="div" to="login">登录阅读全文</router-link>
        </div>
        <div class="buy_now" v-else>
          <p v-if="!islogin">还有&nbsp;{{percentage}}&nbsp;的精彩内容</p>
          <router-link v-if="!islogin" tag="div" to="login">登录阅读全文</router-link>
        </div> -->
      </div>
      <!-- <div class="collect_active" v-show="!is_collection&&islogin&&!need_buy" @click="collection">收藏</div>
      <div
        class="collect_active collect_not"
        v-show="is_collection&&islogin&&!need_buy"
        @click="collection"
      >取消收藏</div> -->
    </div>
    <div class="right_content"></div>
    <div class="gotop" v-show="isgotop" @click="gotop"></div>
  </div>
</template>
<script>
import { addstamp } from "../../utils/stamp";
export default {
  data() {
    return {
      case_id: null,
      follow_title: [],
      detailtArr_follow: [],
      detailtArr_first: [],
      breakArr: [],
      current_page: 1,
      total_pages: null,
      price: 0,
      is_buy: true,
      need_buy: true,
      isfree: false,
      isgotop: false,
      case_name: null,
      islogin: false,
      percentage: null,
      leftsideArr: [],
      is_collection: false,
      collect_id: null,
      meta_title: "",
      is_c:true
    };
  },
  metaInfo() {
    return {
      title: this.meta_title,
    };
  },
  created() {
    if (typeof this.$store.state.user_id != "undefined") {
      this.islogin = true;
    } else {
      this.islogin = false;
    }
    
    if (this.$store.state.mechanism == 'C端账号') {
      this.is_c = true;
    } else {
      this.is_c = false;
    }

    if (this.$route.query.t == 1) {
      this.breakArr = {
        name: this.$route.query.name,
        ksname: this.$route.query.ks,
        type: this.$route.query.t,
      };
    } else if (this.$route.query.t == 2) {
      this.breakArr = {
        name: this.$route.query.name,
        ksname: this.$route.query.ks,
        type: this.$route.query.t,
      };
    } else {
      this.breakArr = {
        name: this.$route.query.name,
        ksname: this.$route.query.ks,
        type: this.$route.query.t,
      };
    }
    this.case_id = this.$route.query.cid;
    this.getDetail();
  },
  mounted() {
    var that = this;
    var two = document.documentElement.clientHeight / 2;
    window.addEventListener("scroll", function (e) {
      var top = document.documentElement.scrollTop;
      if (top > two) {
        that.isgotop = true;
      } else {
        that.isgotop = false;
      }
    });
  },
  methods: {
    alertdialog() {
      this.$alert("该资料暂不对个人用户开放，请联系客服了解详情。", "提示", {
        confirmButtonText: "确定",
      });
    },
    collection() {
      let that = this;
      // this.is_collection = !this.is_collection;
      if (
        this.$store.state.user_id != null &&
        this.$store.state.user_id != "" &&
        typeof this.$store.state.user_id != "undefined"
      ) {
        if (!this.is_collection) {
          //   // this.$message("收藏成功");
          let params = {
            user_id: this.$store.state.user_id,
            type: "case",
            case_id: this.$route.query.cid,
          };
          var sign = addstamp(params);
          delete params.token;
          params["sign"] = sign;
          this.$axios.post("collect", params).then(function (res) {
            // console.log(res);
            if (res.data.status_code == 200) {
              that.is_collection = true;
              that.collect_id = res.data.data.collect_id;
              that.$message({
                message: "收藏成功",
                iconClass: "colloction_icon",
              });
            }
          });
        } else {
          let params = {
            user_id: this.$store.state.user_id,
            collect_id: this.collect_id,
          };
          var sign = addstamp(params);
          delete params.token;
          params["sign"] = sign;
          // console.log(params);
          let url = "collect";
          this.$axios.delete(url, { params }).then(function (res) {
            if (res.data.status_code == 200) {
              // console.log(res);
              that.is_collection = false;
              that.collect_id = null;
            }
          });
        }
      } else {
        this.$router.push({
          path: "/login",
        });
      }
    },
    goAnchor(id) {
      var lis = $("#" + id)[0].offsetTop;
      window.scrollTo(0, lis);
    },
    getDetail() {
      let that = this;
      let url = "zk_an/case/" + this.case_id;
      // 暂定修改《--
      let params = {};
      // let params = {
      //   user_id: this.$store.state.user_id
      // };
      if(!this.is_c){
        params['user_id']=this.$store.state.user_id
      }
      // --》
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      this.$axios.get(url, { params }).then(function (res) {
        if (res.data.status_code == 200) {
          // console.log(res.data.data);
          //   that.detailtArr = res.data.data.info;
          that.is_collection = res.data.data.is_collect;
          that.collect_id = res.data.data.collect_id;
          that.data_handling(res.data.data.info);
          that.price = res.data.data.price / 100;
          that.case_name = res.data.data.case_name;
          that.percentage = res.data.data.percentage;
          that.is_buy = res.data.data.is_buy;
          if (that.is_buy) {
            that.need_buy = false;
          } else {
            if (that.price == -1) {
              // that.isfree = true;
              that.need_buy = false;
            } else if (that.price == 0) {
              // that.isfree = false;
              that.need_buy = false;
            } else if (that.price > 0) {
              // that.isfree = false;
              that.need_buy = true;
            }
          }
          //   else{
          //   }
          //   console.log(that.detailtArr.length)

          let title = 0;
          let tindex = 0;
          let ytitle = 0;
          let yindex = 0;
          for (let i = 0; i < res.data.data.info.first.length; i++) {
            if (res.data.data.info.first[i].name == "出处") {
              title = 1;
              tindex = i;
              break;
            }
          }
          for (let i = 0; i < res.data.data.info.first.length; i++) {
            if (res.data.data.info.first[i].name == "医生") {
              ytitle = 1;
              yindex = i;
              break;
            }
          }
          if (title == 1 && ytitle == 1) {
            that.meta_title =
              that.case_name +
              " " +
              res.data.data.info.first[yindex].value[0] +
              " " +
              res.data.data.info.first[tindex].value[0];
          } else if (title == 1 && ytitle == 0) {
            that.meta_title =
              that.case_name + " " + res.data.data.info.first[tindex].value[0];
          } else if (title == 0 && ytitle == 1) {
            that.meta_title =
              that.case_name + " " + res.data.data.info.first[yindex].value[0];
          } else {
            that.meta_title = that.case_name;
          }
        }
      });
    },
    data_handling(tempArr) {
      let index = 0;
      let count = 8;
      let newTemp = [];
      let newTemp2 = [];
      var chnNumChar = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      var arr = Object.keys(tempArr);
      //   console.log(tempArr);
      //   console.log(arr);
      //   console.log(arr.length);
      //   一诊分割
      for (let i = 0; i < tempArr.first.length; i++) {
        index = parseInt(i / count);
        if (newTemp.length <= index) {
          newTemp.push([]);
        }
        newTemp[index].push(tempArr.first[i]);
      }
      this.detailtArr_first = newTemp;
      // console.log(this.detailtArr_first);
      //   二诊及多诊分割
      if (arr.length > 1) {
        // newTemp = tempArr.first
        this.leftsideArr.push({
          name: "一诊",
          to: "andetail_one",
        });
        for (let i = 0; i < tempArr.followups.length; i++) {
          let moreArr = [];
          let title = i + 2;
          for (let j = 0; j < tempArr.followups[i].length; j++) {
            index = parseInt(i / count);
            if (moreArr.length <= index) {
              moreArr.push([]);
            }
            moreArr[index].push(tempArr.followups[i][j]);
          }
          let params = {
            name: chnNumChar[title] + "诊",
            to: "andetail_follow_" + i,
          };
          // console.log(moreArr)
          newTemp2.push(moreArr);
          this.follow_title.push(chnNumChar[title]);
          this.leftsideArr.push(params);
        }
        this.detailtArr_follow = newTemp2;
        // console.log(newTemp2);
        // console.log(this.leftsideArr);
      }
    },
    goindex(num) {
      if (num == 1) {
        this.$router.push({
          path: "/index",
        });
      } else {
        this.$router.push({
          path: "/an",
          name: "an",
        });
      }
    },
    buy_now() {
      this.$router.push({
        path: "/order",
        query: {
          type: 3,
          cid: this.case_id,
        },
      });
    },
    goablist(num) {
      if (num == 1) {
        this.$router.push({
          path: "/anList",
          query: {
            name: this.breakArr.name,
            ks: this.breakArr.ksname,
            t: this.breakArr.type,
          },
        });
      } else if (num == 2) {
        this.$router.push({
          path: "/anList",
          query: {
            name: this.breakArr.name,
            t: this.breakArr.type,
          },
        });
      } else {
        this.$router.push({
          path: "/anList",
          query: {
            name: this.breakArr.name,
            t: 3,
          },
        });
      }
    },
    // 回到顶部
    gotop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style scoped lang="scss"  type="text/css">
@import "../../assets/style/an/an_detail.scss";
@import "../../assets/style/an/book_nav.scss";
</style>